export default "__VITE_ASSET__CKiiTB4Z__"